import { axiosInstance } from "../axios";

export const registerMakroPayment = async (payment: any) => {
  try {
    const res = await axiosInstance.post('/orders/makro-payment', payment);
    return res.data;
  } catch (error) {
    throw (error)
  }
}